import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { CRUMB_LABEL_KEY, NAME } from '../constants';
import { apiProvider } from '../api';

export const dropdownList = {
	Events: [],
	Frequencies: [],
	ReminderFrequency: [],
	Days: [],
	Months: [],
	WeekDays: [],
};

const edit = {
	Id: null as number | null,
	EventId: null as number | null,
	FrequencyId: null as number | null,
	ScheduleOn: null as string | null,
	ReminderType: null as string | null,
	Reminder: null as number | null,
	IsImmediate: false as boolean | null,
	IsReminder: false as boolean | null,
	MonthDay: null as number | null,
	ScheduleDay: null as number | null,
	ScheduleMonth: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList,
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
